<template>

  <div class="home">
    <mu-container class="index_content">
      <mu-paper :z-depth="1" class="demo-list-wrap">
        <!-- <mu-appbar color="indigo500">
          财务审批
        </mu-appbar> -->
        <mu-list textline="two-line">
          <!-- <mu-sub-header inset>付款申请</mu-sub-header> -->
          <mu-list-item avatar button :ripple="false" class="administrative_list"  :to="{name:'Administrative'}">
            <mu-list-item-action>
              <mu-avatar  color="pink500">
                <mu-icon value="computer"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content >
              <mu-list-item-title>行政费用</mu-list-item-title>
              <mu-list-item-sub-title class="administrative">办公费、宿舍租赁费、通讯费、车辆费、审计费、评估费、顾问费、咨询费、保险费、诉讼费、招聘费、培训费、差旅交通费、交际应酬费</mu-list-item-sub-title>
            </mu-list-item-content>
            <!-- <mu-list-item-action>
              <mu-tooltip content="办公费、宿舍租赁费、通讯费、车辆费、审计费、评估费、顾问费、咨询费、保险费、诉讼费、招聘费、培训费、差旅交通费、交际应酬费">
                <mu-button icon>
                  <mu-icon value="info"></mu-icon>
                </mu-button>
              </mu-tooltip>
              
            </mu-list-item-action> -->
          </mu-list-item>
          <mu-list-item avatar button :ripple="false" :to="{name:'Purchase'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="shopping_cart"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content >
              <mu-list-item-title>采购付款</mu-list-item-title>
              <mu-list-item-sub-title>加工费、材料款</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item>
          <mu-list-item avatar button :ripple="false" :to="{name:'PurchaseLow'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="shopping_cart"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content >
              <mu-list-item-title>采购付款（低值类）</mu-list-item-title>
              <mu-list-item-sub-title>小设备、小器械、工装</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item>
          <mu-list-item avatar button :ripple="false" :to="{name:'Rent'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="store"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>装修设备房租款</mu-list-item-title>
              <mu-list-item-sub-title>医疗及办公设备、装修款、医院房租、资产维修</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item>
          <mu-list-item avatar button :ripple="false"  :to="{name:'WaterFee'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="format_color_fill"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>水电物业费</mu-list-item-title>
            </mu-list-item-content>
          </mu-list-item>
          <mu-list-item avatar button :ripple="false" :to="{name:'Repair'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="build"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>维修费</mu-list-item-title>
            </mu-list-item-content>
          </mu-list-item>
        </mu-list>

        <mu-divider></mu-divider>
        <mu-list textline="two-line">
          <!-- <mu-sub-header inset>发票冲账</mu-sub-header> -->
          <mu-list-item avatar button :ripple="false" :to="{name:'Invoice'}">
            <mu-list-item-action>
              <mu-avatar color="yellow700">
                <mu-icon value="assignment"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>发票冲账</mu-list-item-title>
              <mu-list-item-sub-title>发票冲账、不付款（无账号）</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item>
          
        </mu-list>
        <mu-divider></mu-divider>
        <mu-list textline="two-line">
          <!-- <mu-sub-header inset>借款/还款</mu-sub-header> -->
          <mu-list-item avatar button :ripple="false" :to="{name:'Debit'}">
            <mu-list-item-action>
              <mu-avatar color="yellow700">
                <mu-icon value="monetization_on"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>员工借款</mu-list-item-title>

            </mu-list-item-content>
          </mu-list-item>
          <mu-list-item avatar button :ripple="false"  :to="{name:'PayBack'}">
            <mu-list-item-action>
              <mu-avatar color="yellow700">
                <mu-icon value="all_inclusive"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>还款</mu-list-item-title>
            </mu-list-item-content>
          </mu-list-item>
          
        </mu-list>
        <mu-divider></mu-divider>
        <mu-list textline="two-line">
          <!-- <mu-sub-header inset>付款申请</mu-sub-header> -->
          <mu-list-item avatar button :ripple="false" :to="{name:'Salary'}">
            <mu-list-item-action>
              <mu-avatar  color="blue">
                <mu-icon value="group"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>工资薪酬</mu-list-item-title>
              <mu-list-item-sub-title>工资、奖金、社保公积金</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item>
          <!-- <mu-list-item avatar button :ripple="false" :to="{name:'Refund'}">
            <mu-list-item-action>
              <mu-avatar  color="blue">
                <mu-icon value="hdr_strong"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>退款返现</mu-list-item-title>
              <mu-list-item-sub-title>销售退款、返现</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item> -->
          <mu-list-item avatar button :ripple="false" :to="{name:'Finance'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="timelapse"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>融资类支付</mu-list-item-title>
              <mu-list-item-sub-title>还本、付息、手续费、担保费及其他融资费用</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item>
          <mu-list-item avatar button :ripple="false" :to="{name:'Tax'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="widgets"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>税金支付</mu-list-item-title>
              <mu-list-item-sub-title>各类税金支付</mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item>
          <!-- <mu-list-item avatar button :ripple="false" :to="{name:'Transfer'}">
            <mu-list-item-action>
              <mu-avatar color="blue">
                <mu-icon value="swap_calls"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>资金调拨</mu-list-item-title>
              <mu-list-item-sub-title></mu-list-item-sub-title>
            </mu-list-item-content>
          </mu-list-item> -->

        </mu-list>
        <mu-divider></mu-divider>
        <mu-list textline="two-line">
          <!-- <mu-sub-header inset>借款/还款</mu-sub-header> -->
          <mu-list-item avatar button :ripple="false" :to="{name:'BudgetApplyNew'}">
            <mu-list-item-action>
              <mu-avatar color="yellow700">
                <mu-icon value="monetization_on"></mu-icon>
              </mu-avatar>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>预算申请</mu-list-item-title>

            </mu-list-item-content>
          </mu-list-item>
          
        </mu-list>
        
          
          
      </mu-paper>
    </mu-container>
    
     
    


    <Footer active="Index"></Footer>   
  </div>

  
  

</template>

<script>
// @ is an alias to /src
import Footer from '../components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Footer
  },
  data(){
    return{
      code:'',
      local:window.location.href,
      access_token:'',
      user_info:{},


    }
  },
  created(){
    // this.getCode();
    // console.log(this.$route.query)
    document.title = '财务审批'
    // this.getCode();
    this.hasCookies();

  },
  methods:{
    hasCookies(){
      if(!this.$cookies.isKey('token')){
        var ua = window.navigator.userAgent.toLowerCase();
        console.log(ua);
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          this.$router.push({name:'Login'});
        }else{
          this.$router.push({name:'Web'});
        }
        // this.$router.push({name:'Login'});
      }

    },



  }
}
</script>
<style scoped>

.payment{
  margin:0px 10px 100px 10px;
  padding-top:10px;
}
.icon-container {
  display: flex;
  width: 300px;
  justify-content: space-around;
  margin:0px auto;
}
.icon-container .mu-icon {
  margin-bottom: 12px;
}
.home-container{
    
    padding-top:50px;
    background-color: white;
}
.grid-cell{
    border:1px solid #999;
    margin-right:-1px;
}
.index_content{
  margin-bottom:80px;
}
.mu-sub-header{
  text-align:left;
  
}
/* .mu-list{
  margin-top:5px;
} */
.mu-item-sub-title{
  white-space:normal;
}
.administrative_list{
  margin-top:10px;
  margin-bottom:10px;
}
.administrative{
  height:60px;
}
</style>
<style>
.van-cell__title{
  font-size:1.1em;
  font-family:"Microsoft YaHei";
  font-weight:bold;
}
.van-cell__value{
  font-size:1.1em;
  font-family:"Microsoft YaHei";
  min-width:75%
}
.container{
  padding-left:0px;
  padding-right:0px;
}

</style>


